export enum LANGUAGE {
  ENGLISH_CANADA = 'en-CA',
  FRENCH_CANADA = 'fr-CA',
  SPANISH_MEXICO = 'es-MX',
  SPANISH_COLOMBIA = 'es-CO',
  PORTUGUESE_PORTUGAL = 'pt-PT'
}
